import React from 'react';
import { Link } from 'react-router-dom';
 
class PonenciasCvs extends React.Component {
    render(){
        return (
            <section className="speakers-area-two ptb-120">
                <div className="container">
                    <div id="ramon-barrera" className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="single-speakers-box">
                                <div className="speakers-image">
                                    <img src={require("../../assets/images/ponentes/ramon-barrera.jpg")} alt="speakers" />
                                </div>

                                <div className="speakers-content">
                                    <h3><Link to="#">Ramón Barrera</Link></h3>
                                    <span>Experto en Coaching y en Marketing</span>

                                    </div>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-6">
                            <div className="ponencia">
                                    <h2>Sorprendizaje</h2>
                                    <p>Pasión por educar, eso es lo que transmite nuestro ponente. Él mismo nos cuenta detalles sobre la ponencia: “Sorprendizaje es una palabra que me he inventado, y que es la suma de sorprender y aprender, porque estoy convencido que para aprender te tienes que sorprender y, de la misma manera, los personas que nos dedicamos a enseñar, tenemos que sorprender al alumnado y seguir sorprendiéndonos” </p>
                                    <p>“En esta ponencia trataré de la importancia de gestionar ambientes de aprendizaje, potenciando un entorno de interacción, facilitador de diálogos, de espacios de experimentación, más espontáneos, dinámicos y donde se consiga captar la atención, despertar el interés, estimular la voluntad de aprender y la mejora de los resultados del alumnado”.</p>
                            </div>
                            <hr/>
                            <div className='cv-ponente'>
                                <p>Licenciado en Derecho, Experto en Coaching, Especialista Universitario en Marketing, Postgrado en Diseño y Dirección de Proyectos. Con una amplia formación metodológica y experiencia de formador en competencias como Comunicación, Creatividad, Liderazgo, Gestión del Cambio y Resiliencia, Trabajo en Equipo, Motivación y Productividad Personal, tiene claro cuál es su punto de partida: “apuesta por aquello que sea útil, bonito o divertido”.</p>
                            </div>
                        </div>
                    </div>
               
               
                    <div id ="anna-fores" className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="single-speakers-box">
                                <div className="speakers-image">
                                    <img src={require("../../assets/images/ponentes/anna-fores.jpg")} alt="speakers" />
                                </div>

                                <div className="speakers-content">
                                    <h3><Link to="#">Anna Forés</Link></h3>
                                    <span>Directora adjunta de la Cátedra de Neuroeducación UB</span>

                                    </div>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-6">
                            <div className="ponencia">
                                    <h2>Neuroconexiones</h2>
                                    <p>La educación se puede servir de los avances en neurología para fundamentar y optimizar el proceso educativo, y por ello hemos querido dar un espacio especial a este tema en nuestro congreso. Nuestra ponente expondrá los principios de la neuroeducación para la mejora de la educación. </p>
                            </div>
                            <hr/>
                            <div className='cv-ponente'>
                                    <p>Directora adjunta de la Cátedra de Neuroeducación UB- EDU1ST de la Universidad de Barcelona. </p>
                            </div>
                        </div>
                    </div>



                    <div id="p-victor" className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="single-speakers-box">
                                <div className="speakers-image">
                                    <img src={require("../../assets/images/ponentes/p-victor.jpg")} alt="speakers" />
                                </div>

                                <div className="speakers-content">
                                    <h3><Link to="#">P. Víctor Pérez</Link></h3>
                                    <span>Presidente de la Fundación Pentecostés</span>

                                    </div>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-6">
                            <div className="ponencia">
                                    <h2>Pedagogía cinco estrellas. Un modelo Orgánico, al servicio de algo nuevo</h2>
                                    <p>Presentación del modelo educativo MPK. Un modelo centrado en la persona, los vínculos y su proyección hacia la sociedad, que consigue integrar lo abstracto y concreto, las ideas con la vida, lo individual con lo comunitario, desde una visión global de la persona y del mundo. </p>
                            </div>
                            <hr/>
                            <div className='cv-ponente'>
                                <p>Licenciado en Teología por la Pontificia Universidad Católica de Chile, miembro de los Padres de Schoenstatt, es el presidente de la Fundación Pentecostés, órgano articulador de la red internacional de colegios kentenijianos.</p>
                            </div>
                        </div>
                    </div>

                    <div id="carmen-pellicer" className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="single-speakers-box">
                                <div className="speakers-image">
                                    <img src={require("../../assets/images/ponentes/carmen-pellicer.jpg")} alt="speakers" />
                                </div>

                                <div className="speakers-content">
                                    <h3><Link to="#">Carmen Pellicer</Link></h3>
                                    <span>Presidenta de la Fundación Trilema</span>

                                    </div>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-6">
                            <div className="ponencia">
                                    <h2>Los nuevos profesores. Creando conexiones</h2>
                                    <p>Pasión por educar, eso es lo que transmite nuestro ponente. Él mismo nos cuenta detalles sobre la ponencia: “Sorprendizaje es una palabra que me he inventado, y que es la suma de sorprender y aprender, porque estoy convencido que para aprender te tienes que sorprender y, de la misma manera, los personas que nos dedicamos a enseñar, tenemos que sorprender al alumnado y seguir sorprendiéndonos” </p>
                                    <p>“En esta ponencia trataré de la importancia de gestionar ambientes de aprendizaje, potenciando un entorno de interacción, facilitador de diálogos, de espacios de experimentación, más espontáneos, dinámicos y donde se consiga captar la atención, despertar el interés, estimular la voluntad de aprender y la mejora de los resultados del alumnado”.</p>
                            </div>
                            <hr/>
                            <div className='cv-ponente'>
                                <p>Licenciada en Teología y en Pedagogía, es la presidenta de la Fundación Trilema y de la AECOPE, directora de 'Cuadernos de Pedagogía' y del Máster Learning Leaders de la Universidad Cardenal Spínola CEU de Sevilla.                                    
                                </p>
                                <p>
                                Tiene una amplia experiencia como docente, y más aún en la participación y  puesta en marcha de proyectos de innovación y transformación educativa. Su visión de la educación es una de las máximas referencias en el contexto educativo actual. 
                                </p>
                            </div>
                        </div>
                    </div>
               
                </div>  


                       
            </section>
        );
    }
}
 
export default PonenciasCvs;